import { Button, Form } from 'antd';

export const SubmitButton = () => {
  const form = Form.useFormInstance();

  return (
    <Form.Item className="filter-control" style={{ margin: 0 }}>
      <Button type="primary" onClick={() => form.submit()}>
        Filter
      </Button>
    </Form.Item>
  );
};
